import React from 'react';
import { Body, Button, Modal } from '@walmart-web/livingdesign-components';
import { Link } from 'react-router-dom';
import { ISSUE_CATEGORY } from '../../../../../constants/common';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../../redux/hooks.ts';
import { ihutSelectors } from '../../../../../redux/slices/ihut.ts';
import { IhutActivity } from '../../../../../api/ihut.ts';

type Props = {
  isOpen: boolean;
  handleClose: () => void;
};

const GetSupportModal: React.FC<Props> = ({ isOpen, handleClose }) => {
  const { t } = useTranslation('ihut');
  const activity = useAppSelector(
    ihutSelectors.selectSelectedActivity
  ) as IhutActivity;
  const activityId = activity.ihutProjectId;

  return (
    <Modal
      isOpen={isOpen}
      title={t('support.getSupportTitle')}
      onClose={handleClose}
      actions={
        <Link
          to={{
            pathname: '/contact-us',
            state: {
              activityId,
              issueCategory: ISSUE_CATEGORY.ACTIVITY,
              redirectTo: window.location.pathname
            }
          }}
          style={{ textDecoration: 'none', width: '100%' }}
        >
          <Button variant="primary" size="medium" isFullWidth>
            {t('support.getSupport')}
          </Button>
        </Link>
      }
    >
      <Body UNSAFE_style={{ whiteSpace: 'pre-line' }} size="large">
        {t('support.sorryToHearMessage')}
      </Body>
    </Modal>
  );
};

export default GetSupportModal;
